var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { METHOD } from './types';
import { backendDomain } from '../config';
const mergeRequestHeaders = (headers, mergeObject) => {
    if (!headers)
        return mergeObject;
    return Object.assign(Object.assign({}, headers), mergeObject);
};
const prepRequestForDownload = (request, fileDownloadMimeType) => {
    if (!fileDownloadMimeType)
        return request;
    request.responseType = 'blob';
    request.headers = mergeRequestHeaders(request.headers, {
        Accept: fileDownloadMimeType,
    });
    return request;
};
const prepRequestForUpload = (request, body, filesForUpload, uploadProgressCallback) => {
    if (!filesForUpload)
        return request;
    request.method = METHOD.POST;
    const formData = new FormData();
    if (Array.isArray(filesForUpload)) {
        filesForUpload.forEach((file) => formData.append('files', file));
    }
    if (typeof body === 'object') {
        Object.keys(body).forEach((key) => formData.append(key, body[key]));
    }
    if (typeof body === 'object' && body.token) {
        request.url = `${request.url}?token=${body.token}`;
    }
    request.data = formData;
    request.headers = mergeRequestHeaders(request.headers, { 'Content-Type': 'multipart/form-data' });
    if (typeof uploadProgressCallback === 'function') {
        request.onUploadProgress = (e) => {
            const progress = Math.round((e.loaded / e.total) * 100);
            uploadProgressCallback(progress);
        };
    }
    return request;
};
const fetch = (method, uriSuffix, body = {}, filesForUpload = null, uploadProgressCallback = null, fileDownloadMimeType = null) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!uriSuffix)
            return false;
        let request = {
            method,
            url: `${backendDomain}${uriSuffix}`,
            [method === METHOD.GET ? 'params' : 'data']: body,
        };
        request = prepRequestForDownload(request, fileDownloadMimeType);
        request = prepRequestForUpload(request, body, filesForUpload, uploadProgressCallback);
        if (method === METHOD.GET) {
            request.params.payload = JSON.stringify(body.payload || {});
        }
        const result = yield axios(request);
        return result.data;
    }
    catch (err) {
        return false;
    }
});
export const s3Upload = (presignedURL, file, progressCallback) => __awaiter(void 0, void 0, void 0, function* () {
    const uploadResult = yield axios.put(presignedURL, file, {
        headers: { 'Content-Type': file.type },
        onUploadProgress: (e) => {
            if (typeof progressCallback !== 'function')
                return;
            const progress = Math.round((e.loaded / e.total) * 100);
            progressCallback(progress);
        },
    });
    return uploadResult.status === 200;
});
export default fetch;
